var map = {
	"./1_cn.png": "nsMc",
	"./1_en.png": "dvoH",
	"./1_zhf.png": "Jj91",
	"./2_cn.png": "3CAm",
	"./2_en.png": "qmmZ",
	"./2_zhf.png": "wYrD",
	"./3_cn.png": "OwMv",
	"./3_en.png": "o1nE",
	"./3_zhf.png": "i1LG",
	"./double_en.png": "5F5t",
	"./double_zh_cn.png": "26zr",
	"./double_zh_tw.png": "FAry"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "AfDD";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bj ^\.\/.*\.png$
// module id = AfDD
// module chunks = 0